import { renderMath as etRenderMath, clearMathCache } from "@ever-tutor/et-ui";

export function renderMath(
  element: HTMLElement,
  latex: string,
  { displayFractions = true } = {},
): void {
  etRenderMath(element, latex || "\\text{ }", {
    displayFractions,
    trust: true,
    strict: false,
  });
}

export function clearMathJaxCache(): void {
  clearMathCache();
}
